let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2Yc7I")).then(() => parcelRequire('4elbo'));